import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@fluentui/react-components';
import { Navigate, Outlet, useNavigate } from 'react-router';
import { pagePath } from '#src/app/navigation/module.js';
import { useAccess } from '#src/auth/session.js';
import { StatusScreen } from '#src/shared/StatusScreen.js';
function GoHome() {
    const navigate = useNavigate();
    return (_jsx(Button, { appearance: "primary", onClick: () => navigate('/'), children: "Ir para o in\u00EDcio" }));
}
export function AccessDenied() {
    return (_jsx(StatusScreen, { tone: "denied", title: "Sem acesso a esta p\u00E1gina", description: "O seu perfil n\u00E3o inclui esta funcionalidade. Se precisar dela, pe\u00E7a acesso a um administrador.", action: _jsx(GoHome, {}) }));
}
export function NotFound() {
    return (_jsx(StatusScreen, { title: "P\u00E1gina n\u00E3o encontrada", description: "O endere\u00E7o n\u00E3o existe ou mudou.", action: _jsx(GoHome, {}) }));
}
/** Renderiza as rotas filhas só para quem tem a permissão. */
export function RequirePermission({ permission, }) {
    const can = useAccess();
    return can(permission) ? _jsx(Outlet, {}) : _jsx(AccessDenied, {});
}
/** Entrada do módulo (`/admin`): leva à primeira página que a pessoa pode abrir. */
export function ModuleIndex({ module }) {
    const can = useAccess();
    const first = module.pages.find((page) => can(page.permission));
    if (first === undefined) {
        return _jsx(AccessDenied, {});
    }
    return _jsx(Navigate, { to: pagePath(module, first), replace: true });
}
//# sourceMappingURL=RouteGuards.js.map